@if (appScope.isAuthenticated$ | async) {
  <header class="toolbar-header">
    @if (headerData.show_dtp) {
      <date-time-period class="hideonprint date-period"></date-time-period>
    }
    <div [class.no-dtp]="!headerData.show_dtp" class="page-title row">
      <h1>{{headerData.titleSubject | async}}</h1>
      <div class="buttons row">
        @if (appScope.isNotMobile) {
          <button #button mat-button [matMenuTriggerFor]="pageMenu" #pageMenuTrigger="matMenuTrigger" class="icon-menu"
            style="z-index:1050" matTooltip="Click to view page menu">
            <i class="fas fa-bars" style="font-size: 20px;"></i>
          </button>
          <mat-menu #pageMenu="matMenu" backdropClass="header-menu-backdrop" [hidden]="headerData.buttons.length <= 0"
            class="tree-node-menu dark header-page-menu">
            @for (button of headerData.buttons; track button) {
              @if (!button.toggle) {
                <button (click)="button.func(button.params)"
                  [textContent]="button.name" mat-menu-item>
                </button>
              }
              @if (button.toggle) {
                <mat-slide-toggle (change)="button.func(button.params)"
                  [checked]="button.params.value"
                class="mat-mdc-menu-item" labelPosition="before">{{button.name}}</mat-slide-toggle>
              }
            }
            @if (!restricted_access) {
              @if (headerData.add_edit) {
                <button (click)="openEditForm()" class="hide-xs" mat-menu-item>
                  Edit History
                </button>
              }
            }
            @if (headerData.add_present) {
              <mat-slide-toggle (change)="togglePresent()"
                class="mat-mdc-menu-item" labelPosition="before">Toggle Presentation Mode
              </mat-slide-toggle>
            }
          </mat-menu>
        }
        @if (!restricted_access) {
          @if (headerData.add_print) {
            <button (click)="printToPdf()" class="hide-xs"
              style="color:white !important;padding-left:10px;"
              mat-button matTooltip="Print to PDF"><i class="fas fa-print"
            style="font-size: 18px;padding-left:0;"></i>
          </button>
        }
        @if (headerData.add_upload) {
          <button (click)="uploadData()" class="icon-file-upload"
            mat-button matTooltip="Upload">
            <mat-icon>cloud_upload</mat-icon>
          </button>
        }
        @if (headerData.add_comment) {
          <button (click)="pageCommentButtonClicked()"
            class="icon-comment-invert hideonprint"
            [matTooltip]="headerData.showing_comments && headerData.page_selected=== true ? 'This page is selected for commenting.':'Add comment to page.'"
            [ngClass]="{'show-drawer': headerData.showing_comments && headerData.page_selected === true}">
          </button>
        }
      }
    </div>
  </div>
</header>
}
